import React, {useEffect} from 'react';
import logo from './google-classroom-128.svg';
import humburger from './humburger.svg';
import Drawer from '../Drawer/Drawer';
import classes from './LandingHeader.module.css';

const LandingHeader = () => {
    const [drawerClass, setDrawerClass] = React.useState(classes.hide);
    useEffect(() => {
        const hideDrawer = () => setDrawerClass(classes.hide);
        document.addEventListener('click', hideDrawer);
        return () => {
            document.removeEventListener('click', hideDrawer);
        };
    }, []);

    const showDrawerClass = (e) => {
        e.stopPropagation();
        setDrawerClass(classes.show);
    };

    return (
        <>
        <div className={classes.navigation__container}>
            <div className={classes.navigation__logo}>
                <img alt='logo' src={logo} />
                <a href='/'>
                    <h3>TechStudyGroup</h3>
                </a>
            </div>
            <label onClick={showDrawerClass} role='button' className={classes.mobile_screen_nav__toggle}>
                <img alt='logo' src={humburger} />
            </label>
            <nav className={classes.navigation__links}>
                <a href='/#about_us'>About us</a>
                <a href='/#education'>Syllabus</a>
                <div className={classes.separator} />
                <a href='/#whats_new'>What's New</a>
                <a href='/home'>{"TechStudyGroup"}</a>
                <a href='https://docs.google.com/forms/d/e/1FAIpQLSeFmeKN3vE1yJxAGcliPhCWTySE7J6NU2jOjq4sCY5BCGMYlg/viewform?usp=sf_link' target='_blank' rel="noreferrer">{"Contact Us"}</a>
                {/* {authState.isLoggedIn ? <a href='/home'>{'Hi, ' + authState.UserName}</a> : <a href='/#hero'>Login/Signup</a>} */}
            </nav>
            <Drawer containerClass={drawerClass} />
        </div>
        <div className={classes.navigation__img}>
            <img src='pexels-banner.jpg' alt='programming'>
            </img>
        </div>
        </>
    );
};

export default LandingHeader;
